// extracted by mini-css-extract-plugin
export default {"tableWrapper":"DataTableV2_tableWrapper__MEnqy","table":"DataTableV2_table__K9QKz","clickable":"DataTableV2_clickable__SS8hP","stateCell":"DataTableV2_stateCell__cTq+A"};